import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { css } from "@emotion/react"

export default () => (
  <StaticQuery
    query={graphql`
      query imagePortraitQuery {
        file(relativePath: { eq: "dr-philippe-roure.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 220) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => (
      <Img
        fluid={data.file.childImageSharp.fluid}
        alt="Dr Philippe Roure, chirurgien orthopédiste à Paris spécialiste de la main, du coude et de l'épaule."
        css={css`
          width: 100%;
          float: left;
          margin-right: 20px;
          margin-bottom: 10px;
          border-radius: 5px;
        `}
      />
    )}
  />
)
